module.exports = __webpack_public_path__ + "img/pick3.322b4949.png";